import m from 'mithril';

// let typeahead_state = {
//     base_data_url: 'https://data.ijf.org/api/get_json?params[action]=person.get_list',
//     query: '',
//     visible: false,
//     timeout: null,

//     getData: null,
//     getItemText: null,
//     onItemSelect: null,

//     selected: null,

//     data_state: {
//         results: [],
//         is_loading: false,
//     },

//     placeholder: '',
//     no_results_text: 'No results',
// }

class TypeaheadElement {
    view (vnode) {
        let item = vnode.attrs.item;
        let i = vnode.attrs.i;
        let onSelect = vnode.attrs.onSelect;
        let state = vnode.attrs.state;

        return  m('div.typeahead__element' + (state.selected != null && state.selected==i ? '.typeahead__element__selected' : ''), {
                    onclick: e => {
                        e.preventDefault();
                        state.selected = i;
                        onSelect(i, state);
                    }
                },
                state.getItemText(item));
    }
}

class Typeahead {
    oncreate(vnode) {
        this.el = vnode.dom;
    }

    oninit(vnode) {
        this.typeahead_state = {
            query: '',
            visible: false,
            timeout: null,

            getData: null,
            getItemText: null,
            onItemSelect: null,
            onItemSelectParams: null,

            selected: null,

            data_state: {
                results: [],
                is_loading: false,
            },

            placeholder: '',
            no_results_text: 'No results',
            value: null
        }


        this.typeahead_state.getData = vnode.attrs.getData;
        this.typeahead_state.getItemText = vnode.attrs.getItemText;
        this.typeahead_state.onItemSelect = vnode.attrs.onItemSelect;
        this.typeahead_state.onItemSelectParams = vnode.attrs.onItemSelectParams;
        this.typeahead_state.placeholder = vnode.attrs.placeholder;
        this.typeahead_state.getValue = vnode.attrs.getValue;

        if (vnode.attrs.noResultsText)
            this.typeahead_state.no_results_text = vnode.attrs.noResultsText;

        if (!vnode.attrs.getValue) 
            this.typeahead_state.getValue = _ => null;
    }

    onSelect(i, state) {
        if (i == null || i < 0 || i > state.data_state.results.length-1)
            return

        state.visible = false;

        let selectedElement = state.data_state.results[i];

        state.onItemSelect(selectedElement, state.onItemSelectParams);

        state.value = state.getValue();
        m.redraw();
    }

    moveSelected(e) {
        let keyCode = e.keyCode;

        if (keyCode == 38) {
            if (this.typeahead_state.selected == null) {
                this.typeahead_state.selected = 0;
            } else if (this.typeahead_state.selected >= 1) {
                this.typeahead_state.selected = this.typeahead_state.selected - 1;
            }
        }

        if (keyCode == 40) {
            if (this.typeahead_state.selected == null) {
                this.typeahead_state.selected = 0;
            } else if (this.typeahead_state.selected < this.typeahead_state.data_state.results.length - 1 ) {
                this.typeahead_state.selected = this.typeahead_state.selected + 1;
            }
        }


        // let element = vnode.dom;
        // let element = document.querySelector('.typeahead-container .typeahead').children.item(this.typeahead_state.selected);
        let element = this.el.querySelector('.typeahead').children.item(this.typeahead_state.selected);
        let container = element.parentElement;

        let cTop = container.scrollTop;
        let cBottom = cTop + container.clientHeight;

        let eTop = element.offsetTop;
        let eBottom = eTop + element.clientHeight;

        if (eTop < cTop) {
            container.scrollTop -= (cTop - eTop);
        }
        else if (eBottom > cBottom) {
            container.scrollTop += (eBottom - cBottom);
        }

        m.redraw();
    }

    typeaheadInput() {
        return m('input', {
            // value: this.typeahead_state.query,
            value: this.typeahead_state.value,
            placeholder: this.typeahead_state.placeholder,

            onkeyup: e => {
                let keyCode = e.keyCode;

                if (keyCode == 38 || keyCode == 40) {
                    e.preventDefault();
                    this.moveSelected(e);
                    return;
                }

                if (keyCode == 13) {
                    e.preventDefault();
                    e.target.blur();
                    this.onSelect(this.typeahead_state.selected, this.typeahead_state);
                    return;
                }

                this.typeahead_state.query = e.target.value;
                
                clearTimeout(this.typeahead_state.timeout);

                if (this.typeahead_state.query.length > 0) {
                    this.typeahead_state.visible = true;
                    this.typeahead_state.data_state.is_loading = true;

                    this.typeahead_state.timeout = setTimeout(e => { 
                        this.typeahead_state.getData(this.typeahead_state.query, this.typeahead_state.data_state)
                    }, 500);
                } else {
                    this.typeahead_state.visible = false;
                }
            },

            onfocus: e => {
                if (this.typeahead_state.query.length > 0) {
                    this.typeahead_state.value = null;
                    this.typeahead_state.visible = true;
                }
            },

            onblur: e => {
                setTimeout(e => {
                    this.typeahead_state.visible = false;
                    m.redraw()
                }, 150);
            }
        });
    }

    typeaheadResults() {
        return  m('div', 
            {
                class: 'typeahead ' + (this.typeahead_state.visible ? '' : 'typeahead--hidden')
            },
            [
                this.typeahead_state.data_state.is_loading && this.typeahead_state.query.length > 0 &&
                    m('div.typeahead__element.typeahead__element--loading', ''),

                this.typeahead_state.data_state.results.length > 0 && !this.typeahead_state.data_state.is_loading && this.typeahead_state.query.length > 0 &&
                    this.typeahead_state.data_state.results.map((item, i) => {
                        return m(TypeaheadElement, {i: i, item: item, onSelect: this.onSelect, state: this.typeahead_state})
                    }),

                this.typeahead_state.data_state.results.length == 0 && !this.typeahead_state.data_state.is_loading && this.typeahead_state.query.length > 0 &&
                    m('div.typeahead__element.typeahead__element--text', this.typeahead_state.no_results_text)
            ]
        );
    }

    view() {
        return m('.typeahead-container', [
            m('div', [
                m('div', [
                    this.typeaheadInput(),
                ]),
            ]),
            this.typeaheadResults()
        ]);
    }
}

export default Typeahead;